import { openDB } from "idb";

const DB_NAME="hr-db";
const STORE_NAME="orgDataStore";
const KEY="orgData";

const getDB=()=>
    openDB(DB_NAME, 1, {
        upgrade(db){
            if(!db.objectStoreNames.contains(STORE_NAME)){
                db.createObjectStore(STORE_NAME);
            }
        }
    });

const ORG_KEY="orgData";
const SIM_KEY="simulationData";

export const saveOrgData=async(data)=>{
    const db=await getDB();
    await db.put(STORE_NAME, data, KEY);
}
export const loadOrgData=async()=>{
    const db=await getDB();
    return await db.get(STORE_NAME, KEY)
}

export const saveSimulationData=async(data)=>{
    const db=await getDB();
    await db.put(STORE_NAME, data, SIM_KEY);
}
export const loadSimulationData=async()=>{
    const db=await getDB();
    return await db.get(STORE_NAME, SIM_KEY)
}